const SuccessView = ({ resetAndClose }) => (
    <div className="success-container text-center">
        <h5>
            <T>auth.sign.up.success.part.1</T>{' '}
            <Link style={{ fontWeight: 'bold' }} to="/dashboard" onClick={resetAndClose}>
                <T>auth.sign.up.success.part.2</T>
            </Link>{' '}
            <T>auth.sign.up.success.part.3</T>
        </h5>
    </div>
)

export default SuccessView
